import { request } from './interceptors';
import { createInstance } from './utils';

const AuthInstance = createInstance();

AuthInstance.interceptors.request.use(request);

export default AuthInstance;
